import {
  setCognitoUser,
  resetCognitoUser,
  setUserLoginErrors,
  resetUserLoginErrors,
  setIsLogout,
  setIsLoggedIn,
  setChallengedUser,
  setIsMandatoryDataFetched
} from "./auth";
import {
  setMarketIso,
  setUserMarketFilter,
  setUserMarkets,
  setUserRoles,
  resetUserRoles,
  setLocations,
  resetLocations,
  setLoading as setLocationsLoading,
  setLoadingId as setLoadingLocationId,
  removeLoadingId as removeLoadingLocationId,
  setError as setLocationsError,
  setUserAppTypes,
  setAppTypesGroups,
  setGroupsConfigs,
  resetGroupsConfigs,
  setAppVersion,
  setIsNeedToResetTextEditorState
} from "./configs";
import {
  setDarkMode,
  setTableRowsPerPage,
  pushActiveNotification,
  filterActiveNotifications,
  pushCreatedTableRowsIds,
  clearCreatedTableRowsIds,
  setBreadcrumbsRedirectUrl,
  setNotificationCenterActiveTab,
  setFleetManagementActiveTab,
  setSelectedTableRowsIds,
  clearSelectedTableRowsIds
} from "./global";
import {
  setLanguageList,
  setLanguage,
  setLanguageFile,
  setDefaultLanguageFile
} from "./localization";
import {
  setPeriod,
  setAppType,
  setDatesRange,
  setDevice,
  setMarket,
  setPlatform,
  setLocation,
  setBrowser,
  setGroup,
  setConnectivity,
  setSelectedPeriod,
  setSelectedAppType,
  setSelectedFromDate,
  setSelectedToDate,
  setSelectedDevice,
  setLocationOptions,
  setSelectedMarket,
  setSelectedLocation,
  setSelectedPlatform,
  setSelectedBrowser,
  setSelectedGroup,
  setIsFiltersSet,
  resetSelectedFilters,
  resetAppliedFilters,
  setIsFiltersChanged,
  setSelectedConnectivity,
  setIsDashboardFilterAppChanged
} from "./dashboardFilters";
import {
  setDashboardEmbedUrl,
  setSelectedDashboardId,
  setAvailableDashboards as setAvailableSmartDashboards
} from "./dashboard";
import {
  setEventsFetched,
  setMarketEventsFetched,
  setIsFiltersPanelVisible,
  setChartFilters,
  setLoadingCharts,
  setLoadedChart,
  setRefresh as setEventsRefresh,
  setMarketRefresh as setMarketEventsRefresh,
  setErrorCharts,
  resetErrorCharts,

  // Events
  // ______________________________________________________________________
  setPageLoadsEvents,
  setConnectionTimeEvents,
  setDeviceUsageEvents,
  setDiagnosticsEvents,
  setSettingEvents,
  setFwuEvents,
  setReconnectionTimeEvents,
  setBatteryHealthEvents,
  setDiagnosticsErrorsReadingPerfomanceEvents,
  // Statistics by market
  setConnectionsByMarket,
  setDiagnosticsByMarket,
  setFwuByMarket,
  setConnectionsByBrowser,
  setConnectionsByOS,
  resetEvents,
  resetMarketEvents
} from "./rum";
import {
  pushUsers,
  resetUsers,
  setLoading as setUsersLoading,
  setRefresh as setUsersRefresh,
  setError as setUsersError,
  setUserToEdit,
  setFilters as setUserFilters
} from "./users";
import {
  pushMarkets,
  resetMarkets,
  setLoading as setMarketsLoading,
  setRefresh as setMarketsRefresh,
  setError as setMarketsError
} from "./markets";
import {
  setConsents,
  resetConsents,
  setSelectedConsent,
  setConsentElements,
  insertConsentElement,
  alignConsentElementTexts,
  resetConsentElements,
  setSelectedConsentElement,
  setConsentElementsVisibility,
  setMarket as setConsentsMarket,
  setAppType as setConsentsAppType,
  setIsDuplicate,
  setIsViewOnly,
  setLoading as setConsentsLoading,
  setRefresh as setConsentsRefresh,
  setConsentsError,
  setConsentElementsError,
  setDuplicateConsentId
} from "./consents";
import {
  pushApps,
  resetApps,
  setError as setAppsError,
  setRefresh as setAppsRefresh,
  setLoading as setAppsLoading,
  setAppsMarkets,
  setSelectedApp,
  resetSelectedApp,
  setManageType,
  setGroupToSelectedApp,
  setSelectedAppMarketsToAdd,
  setSelectedAppMarketsToDelete,
  resetSelectedAppMarketsToAdd,
  resetSelectedAppMarketsToDelete,
  setActivePage,
  setLastActiveIndex,
  setIsGeneralInfoSaved,
  setGroupError,
  setAvailableDashboards,
  setOriginalAvailableDashboards,
  setOriginalEmailMessage,
  setIsEmailMessageEditing,
  addLocalizationToApp,
  deleteAppLocaliztion,
  setLocalizationToApp,
  setLocaleKeys,
  setIsNeedRefetchLocales,
  setIsMissingKeysModalActive,
  setMissingKeysModalData,
  setEditingLocale,
  setOriginalDefaultLocale,
  setMissingKeysModalLocalization,
  setIsMissingKeysModalLocalizationUploaded,
  setIsFileUploadDeclined,
  setFeaturesModalData,
  setIsFeaturesActive,
  setIsFeaturesActiveSetted,
  setIsMarketsReassigned,
  setIsRolesReassigned,
  setPrevAppType,
  setOriginalAppLink,
  setOriginalAppName,
  setIsOriginalEmailSetted,
  setOriginalMarketLocalizations,
  setOriginalLocalizations,
  setIsSavingPending,
  setPrevLocale
} from "./apps";

import {
  setNotifications,
  setSystemNotifications,
  resetNotifications,
  resetSystemNotifications,
  setLoading as setNotificationsLoading,
  setRefresh as setNotificationsRefresh,
  setError as setNotificationsError,
  setNotificationToEdit,
  setNotificationImage
} from "./notifications";

import {
  setFWUCampaigns,
  setFWUCampaignToEdit,
  setFWUCampaignDetails,
  pushReleaseNotes,
  resetFWUCampaigns,
  resetReleaseNotesList,
  setLoading as setFwuCampaingsLoading,
  setRefresh as setFwuCampaingsRefresh,
  setError as setFwuCampaingsError,
  setFwuCampaignDetailsRefresh
} from "./fwuCampaigns";

import {
  setNotificationCampaigns,
  setNotificationCampaignToEdit,
  setLoading as setNotificationCampaignsLoading,
  setRefresh as setNotificationCampaignsRefresh,
  setError as setNotificationCampaignsError,
  setNotificationCampaignDetailsRefresh,
  setNotificationCampaignDetails
} from "./notificationCampaigns";

import {
  setFWUVersions,
  resetFWUVersions,
  setFWUVersionToEdit,
  setFWUVersionToDelete,
  setReleaseNotes,
  pushReleaseNotesMedia,
  resetReleaseNotesMedia,
  pushReleaseNotesThumbnails,
  resetReleaseNotesThumbnails,
  setReleaseNotesLoading,
  setError as setFWUVersionsError,
  setRefresh as setFWUVersionsRefresh,
  setLoading as setFWUVersionsLoading,
  setLoadingChanges as setFWUVersionsLoadingChanges
} from "./fwuVersions";

import {
  pushDevices,
  setDeviceToEdit,
  pushDeviceKitList,
  resetDeviceKitList,
  setCertificateUrl,
  setFailedCertificateDusns,
  resetDevices,
  setLoading as setDevicesLoading,
  setRefresh as setDevicesRefresh,
  setError as setDevicesError,
  setFWUFilters,
  setDeviceFilters,
  setFwVersionFilters
} from "./fleetManagement";

import {
  setDeviceChangeHistory,
  resetDeviceChangeHistory,
  setLoading as setDeviceChangeHistoryLoading,
  setRefresh as setDeviceChangeHistoryRefresh,
  setError as setDeviceChangeHistoryError
} from "./deviceChangeHistory";

import {
  pushGroups,
  resetGroups,
  setError as setUserGroupError,
  setLoading as setUserGroupLoading,
  setRefresh as setUserGroupRefresh,
  clearDeletedGroups,
  setDeletedGroups
} from "./userGroups";

import {
  setDeviceGroupsList,
  resetDeviceGroupsList,
  setDeviceGroups,
  resetDeviceGroups,
  setLoading as setDeviceGroupsLoading,
  setRefresh as setDeviceGroupsRefresh,
  setDeviceGroupsListLoading,
  setDeviceGroupsListRefresh
} from "./deviceGroups";

import {
  pushHardware,
  resetHardware,
  pushMercuryHardware,
  resetMercuryHardware,
  setLoading as setHardwareLoading,
  setRefresh as setHardwareRefresh,
  setError as setHardwareError,
  setMercuryHardwareLoading,
  setMercuryHardwareRefresh
} from "./hardware";

import { setUserInsightsFilters } from "./userIsights";

export {
  setCognitoUser,
  resetCognitoUser,
  setUserLoginErrors,
  resetUserLoginErrors,
  setIsLogout,
  setMarketIso,
  setUserMarketFilter,
  setUserMarkets,
  setUserRoles,
  resetUserRoles,
  setLocations,
  resetLocations,
  setLocationsLoading,
  setLoadingLocationId,
  removeLoadingLocationId,
  setLocationsError,
  setUserAppTypes,
  setDarkMode,
  setTableRowsPerPage,
  pushActiveNotification,
  filterActiveNotifications,
  setLanguageList,
  setLanguage,
  setLanguageFile,
  setDefaultLanguageFile,
  setEventsFetched,
  setMarketEventsFetched,
  setIsFiltersPanelVisible,
  setChartFilters,
  setLoadingCharts,
  setLoadedChart,
  setEventsRefresh,
  setMarketEventsRefresh,
  setErrorCharts,
  resetErrorCharts,
  setPageLoadsEvents,
  setConnectionTimeEvents,
  setDeviceUsageEvents,
  setDiagnosticsEvents,
  setSettingEvents,
  setFwuEvents,
  setReconnectionTimeEvents,
  setBatteryHealthEvents,
  setConnectionsByMarket,
  setDiagnosticsByMarket,
  setFwuByMarket,
  resetEvents,
  resetMarketEvents,
  pushUsers,
  resetUsers,
  setUsersLoading,
  setUsersRefresh,
  setUsersError,
  setPeriod,
  setDatesRange,
  setDevice,
  setMarket,
  setPlatform,
  setLocation,
  setBrowser,
  setSelectedPeriod,
  setSelectedFromDate,
  setSelectedToDate,
  setSelectedDevice,
  setLocationOptions,
  setSelectedMarket,
  setSelectedLocation,
  setSelectedPlatform,
  setSelectedBrowser,
  setIsFiltersSet,
  resetSelectedFilters,
  resetAppliedFilters,
  setConsents,
  resetConsents,
  setSelectedConsent,
  setConsentElements,
  insertConsentElement,
  alignConsentElementTexts,
  resetConsentElements,
  setSelectedConsentElement,
  setConsentElementsVisibility,
  setConsentsMarket,
  setConsentsAppType,
  setIsDuplicate,
  setIsViewOnly,
  setConsentsLoading,
  setConsentsRefresh,
  setConsentsError,
  setConsentElementsError,
  pushCreatedTableRowsIds,
  clearCreatedTableRowsIds,
  setAppType,
  setSelectedAppType,
  setGroup,
  setSelectedGroup,
  setIsFiltersChanged,
  pushMarkets,
  resetMarkets,
  setMarketsLoading,
  setMarketsRefresh,
  setMarketsError,
  setAppTypesGroups,
  setGroupsConfigs,
  resetGroupsConfigs,
  setAppVersion,
  setConnectionsByOS,
  setConnectionsByBrowser,
  setDiagnosticsErrorsReadingPerfomanceEvents,
  setConnectivity,
  setSelectedConnectivity,
  pushApps,
  resetApps,
  setAppsError,
  setAppsRefresh,
  setAppsLoading,
  setAppsMarkets,
  setSelectedApp,
  resetSelectedApp,
  setManageType,
  setIsLoggedIn,
  setGroupToSelectedApp,
  setSelectedAppMarketsToAdd,
  setSelectedAppMarketsToDelete,
  resetSelectedAppMarketsToAdd,
  resetSelectedAppMarketsToDelete,
  setActivePage,
  setLastActiveIndex,
  setIsGeneralInfoSaved,
  setAvailableDashboards,
  setGroupError,
  setOriginalAvailableDashboards,
  setOriginalEmailMessage,
  setIsEmailMessageEditing,
  setIsNeedToResetTextEditorState,
  setUserToEdit,
  addLocalizationToApp,
  deleteAppLocaliztion,
  setLocalizationToApp,
  setLocaleKeys,
  setIsNeedRefetchLocales,
  setEditingLocale,
  setOriginalDefaultLocale,
  setIsMissingKeysModalActive,
  setMissingKeysModalData,
  setMissingKeysModalLocalization,
  setIsMissingKeysModalLocalizationUploaded,
  setIsFileUploadDeclined,
  setFeaturesModalData,
  setIsFeaturesActive,
  setIsFeaturesActiveSetted,
  setIsMarketsReassigned,
  setIsRolesReassigned,
  setPrevAppType,
  setIsDashboardFilterAppChanged,
  setOriginalAppLink,
  setOriginalAppName,
  setIsOriginalEmailSetted,
  setOriginalMarketLocalizations,
  setOriginalLocalizations,
  setIsSavingPending,
  setPrevLocale,
  setBreadcrumbsRedirectUrl,
  setNotifications,
  setSystemNotifications,
  resetNotifications,
  resetSystemNotifications,
  setNotificationsLoading,
  setNotificationsRefresh,
  setNotificationsError,
  setNotificationToEdit,
  setNotificationImage,
  setFWUCampaigns,
  setFWUCampaignToEdit,
  setFWUCampaignDetails,
  pushReleaseNotes,
  resetFWUCampaigns,
  resetReleaseNotesList,
  setFwuCampaingsLoading,
  setFwuCampaingsRefresh,
  setFwuCampaingsError,
  setFwuCampaignDetailsRefresh,
  setFWUVersions,
  resetFWUVersions,
  setFWUVersionToEdit,
  setFWUVersionToDelete,
  setReleaseNotes,
  pushReleaseNotesMedia,
  resetReleaseNotesMedia,
  pushReleaseNotesThumbnails,
  resetReleaseNotesThumbnails,
  setReleaseNotesLoading,
  setFWUVersionsLoading,
  setFWUVersionsLoadingChanges,
  setFWUVersionsError,
  setFWUVersionsRefresh,
  setNotificationCampaigns,
  setNotificationCampaignToEdit,
  setNotificationCampaignsLoading,
  setNotificationCampaignsRefresh,
  setNotificationCampaignsError,
  setChallengedUser,
  setIsMandatoryDataFetched,
  pushDevices,
  setDeviceToEdit,
  pushDeviceKitList,
  resetDeviceKitList,
  setCertificateUrl,
  setFailedCertificateDusns,
  resetDevices,
  setDevicesLoading,
  setDevicesRefresh,
  setDevicesError,
  setDashboardEmbedUrl,
  setSelectedDashboardId,
  setAvailableSmartDashboards,
  setNotificationCampaignDetailsRefresh,
  setNotificationCampaignDetails,
  setNotificationCenterActiveTab,
  setFleetManagementActiveTab,
  setDeviceChangeHistory,
  resetDeviceChangeHistory,
  setDeviceChangeHistoryLoading,
  setDeviceChangeHistoryRefresh,
  setDeviceChangeHistoryError,
  setSelectedTableRowsIds,
  clearSelectedTableRowsIds,
  setDuplicateConsentId,
  pushGroups,
  resetGroups,
  setUserGroupError,
  setUserGroupLoading,
  setUserGroupRefresh,
  setUserFilters,
  clearDeletedGroups,
  setDeletedGroups,
  setFWUFilters,
  setDeviceFilters,
  setFwVersionFilters,
  setDeviceGroupsList,
  resetDeviceGroupsList,
  setDeviceGroups,
  resetDeviceGroups,
  setDeviceGroupsLoading,
  setDeviceGroupsRefresh,
  setDeviceGroupsListLoading,
  setDeviceGroupsListRefresh,
  pushHardware,
  resetHardware,
  pushMercuryHardware,
  resetMercuryHardware,
  setHardwareLoading,
  setHardwareRefresh,
  setHardwareError,
  setUserInsightsFilters,
  setMercuryHardwareLoading,
  setMercuryHardwareRefresh
};
